import { render, staticRenderFns } from "./UIPostGuideCard.vue?vue&type=template&id=63d9cecd&scoped=true"
import script from "./UIPostGuideCard.vue?vue&type=script&lang=js"
export * from "./UIPostGuideCard.vue?vue&type=script&lang=js"
import style0 from "./UIPostGuideCard.vue?vue&type=style&index=0&id=63d9cecd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d9cecd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default,TruncateParagraph: require('/skade-pwa/components/ui/atom/TruncateParagraph.vue').default})
